import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { BackendModule, ReadCallback } from 'i18next'

export const locales = {
  da_DK: 'Dansk',
  en_US: 'English (United States)',
  en_GB: 'English (United Kingdom)',
  pl_PL: 'Język polski',
  de_DE: 'Deutsch',
  es_ES: 'Español',
  fr_FR: 'Français',
  nn_NO: 'Norsk (Nynorsk)',
  nb_NO: 'Norsk (Bokmål)',
  sv_SE: 'Svenska',
  it_IT: 'Italiano',
  nl_NL: 'Nederlands',
  fi_FI: 'Suomi',
  ja_JP: '日本語',
  tr_TR: 'Türkçe',
}

export const currentTranslatedLocales = {
  da_DK: 'Dansk',
  en_US: 'English (United States)',
  en_GB: 'English (United Kingdom)',
  sv_SE: 'Svenska',
  de_DE: 'Deutsch',
  fr_FR: 'Français',
  fi_FI: 'Suomi',
  ja_JP: '日本語',
  nn_NO: 'Norsk (Nynorsk)',
  nb_NO: 'Norsk (Bokmål)',
  tr_TR: 'Türkçe',
}

export const enLocaleNames = {
  da_DK: 'Danish',
  en_US: 'English (United States)',
  en_GB: 'English (United Kingdom)',
  sv_SE: 'Swedish',
  de_DE: 'German',
  fr_FR: 'French',
  ja_JP: 'Japanese',
  fi_FI: 'Finnish',
  nb_NO: 'Norwegian (Bokmål)',
  nn_NO: 'Norwegian (Nynorsk)',
  zh_CN: 'Chinese',
  ko_KR: 'Korean',
  tr_TR: 'Turkish',
}

class I18onBackend implements BackendModule {
  type = 'backend' as const

  init() {}

  async read(language: string, namespace: string, callback: ReadCallback) {
    const languageToUse = language === 'en' ? 'en_US' : language

    try {
      const res = await fetch(
        `${
          import.meta.env.VITE_ENDPOINT_GRAPHQL
        }/translations/${languageToUse}`,
      )

      const data = await res.json()

      callback(null, data)
    } catch (e) {
      console.error((e as Error).message)
      callback(new Error((e as Error).message), null)
    }
  }

  save() {
    console.info('save not implemented')
  }

  create() {
    console.info('create not implemented')
  }
}
// @ts-ignore
I18onBackend.type = 'backend'

const i18next = async (options = {}) => {
  const i18noptions = {
    fallbackLng: false,
    appendNamespaceToCIMode: true,
    saveMissing: false,
    sendMissingTo: 'all',
    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',
    debug: false,
    keySeparator: '### not used ###', // we use content as keys
    nsSeparator: '### not used ###', // we use content as keys
    interpolation: {
      escapeValue: false, // not needed for react!!
      formatSeparator: ',',
      format: (value: string, format: string) => {
        if (format === 'uppercase') return value.toUpperCase()
        return value
      },
    },
    react: {
      wait: true,
      useSuspense: false,
    },
    returnNull: false,
    backend: {
      projectId: 'clhfzrbil0000l815r1lyxnzl',
    },
    ...options,
  }

  return new Promise(resolve => {
    // Expose to make it accessible outside components
    window.i18n = i18n
      .use(I18onBackend)
      .use(initReactI18next)
      .init(i18noptions as any)

    resolve(window.i18n)
  })
}

export default i18next
